import React from "react";
import { Card, CardHeader, CardBody, Button, Alert } from "reactstrap";
import { useNavigate } from "react-router-dom";

function renderSubscriptionStatus(status) {
    const map = {
        active: { label: "Active", className: "badge bg-success-subtle text-success" },
        past_due: { label: "Past due", className: "badge bg-warning-subtle text-warning" },
        incomplete: { label: "Incomplete", className: "badge bg-secondary-subtle text-secondary" },
        canceled: { label: "Canceled", className: "badge bg-danger-subtle text-danger" },
        none: { label: "Not subscribed", className: "badge bg-light text-muted border" },
    };
    const s = map[status] || map.none;
    return <span className={s.className}>{s.label}</span>;
}

export default function BaxRxPlusSummaryCard({ status, eligibilityNote, onManage, user }) {
    const navigate = useNavigate();
    const isDependent = user?.dependentContext?.isDependent;
    const primaryMember = user?.dependentContext?.primaryMember;
    const statusInheritedFromPrimary = user?.dependentContext?.statusInheritedFromPrimary;

    const eligibleText =
        status === "active" ? "Eligible for all BaxRx+ benefits" : "Not currently subscribed";

    const handleViewPrimaryAccount = () => {
        if (primaryMember?.userId) {
            navigate(`/admin/member-management/${primaryMember.userId}`);
        }
    };

    return (
        <Card className="border">
            <CardHeader style={{ background: "var(--thead-bg)" }}>
                <h5 className="mb-0">BaxRx+ Subscription</h5>
            </CardHeader>
            <CardBody>
                <div className="d-flex align-items-center mb-3">
                    <span className="fw-medium me-2">Status:</span>
                    {renderSubscriptionStatus(status)}
                    {isDependent && statusInheritedFromPrimary && (
                        <span className="badge bg-info-subtle text-info ms-2" style={{ fontSize: '0.7rem' }}>
                            <i className="ri-link me-1"></i>Inherited
                        </span>
                    )}
                </div>

                {isDependent && statusInheritedFromPrimary && primaryMember ? (
                    <>
                        <Alert color="info" className="mb-3 py-2 px-3">
                            <div className="d-flex align-items-start">
                                <i className="ri-information-line me-2 mt-1"></i>
                                <div className="flex-grow-1">
                                    <small className="d-block mb-1">
                                        <strong>Subscription managed by primary account holder</strong>
                                    </small>
                                    <small className="text-muted d-block">
                                        This dependent's subscription status is inherited from the primary member account.
                                    </small>
                                </div>
                            </div>
                        </Alert>

                        <div className="mb-3">
                            <span className="fw-medium d-block mb-2">Primary Account:</span>
                            <div className="p-2 bg-light rounded">
                                <small className="text-muted d-block">{primaryMember.name}</small>
                                <small className="text-muted d-block">{primaryMember.email}</small>
                                <small className="text-muted">Member ID: #{primaryMember.memberId}</small>
                            </div>
                        </div>

                        <Button
                            color="outline-primary"
                            size="sm"
                            className="w-100"
                            onClick={handleViewPrimaryAccount}
                        >
                            <i className="ri-user-line me-2" />
                            View Primary Account
                        </Button>
                    </>
                ) : (
                    <>
                        <div className="mb-3">
                            <span className="fw-medium">Eligibility:</span>
                            <p className="text-muted mb-2">
                                {eligibleText}
                                {eligibilityNote ? ` — ${eligibilityNote}` : ""}
                            </p>
                        </div>

                        <Button
                            color="outline-info"
                            size="sm"
                            className="w-100"
                            onClick={onManage}
                        // disabled={status !== "active"}
                        >
                            <i className="ri-settings-3-line me-2" />
                            Manage Subscription
                        </Button>
                    </>
                )}
            </CardBody>
        </Card>
    );
}